import { useEffect, useRef, useState } from 'react'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { getGenerateProgress, getTaskDetail, generateDetail } from '../../net'
import style from './result.module.css'
import {
	generateProgressAtom,
	promptAtom,
	stopChatAtom,
	taskDetailAtom,
	taskInitAtom,
	generateStageAtom,
	meshProfileAtom,
	modelHideAtom,
	currentCardsAtom,
	imgurlsAtom,
	taskidAtom,
	generateprocessAtom,
	generatestateAtom,
	generateurlsAtom,
	imgCardAtom,
	isUploadingAtom,
	imgfileAtom,
	generatedAtom,
	generatingAtom
} from './store'
import { startChat,ImaginefaceSubmit,ImaginefaceSelection,ImaginefaceGenerate } from '../../net'
import { logInfoAtom } from '../Header/store'
import { BsCloudArrowUpFill } from 'react-icons/bs';
import ImagePng from '../../assets/image.png'
import TextPng from '../../assets/text.png'

function GenerateBoard() {
	const [imgfile, setImgfile] = useRecoilState(imgfileAtom)
	const [, setShowImgBox] = useState(false);
	const [imgurls, setImgurls] = useRecoilState(imgurlsAtom)
	const [taskid, setTaskid] = useRecoilState(taskidAtom)
	const [,setGenerateurls]=useRecoilState(generateurlsAtom)
	const [, setGenerateprocess] = useRecoilState(generateprocessAtom)
	const [, setGeneratestate] = useRecoilState(generatestateAtom)
	const [prompt, setPrompt] = useRecoilState(promptAtom)
	const taskInit = useRecoilValue(taskInitAtom)
	const [taskDetail, setTaskDetail] = useRecoilState(taskDetailAtom)
	const intervalRef = useRef(null)
	const intervalImgRef = useRef(null)
	const fileInputRef=useRef(null)
	const intervalSelectionId=useRef(null)
	const [uploadImgBlob, setUploadImgBlob] = useState(null);
	const [fileDropHover, setFileDropHover] = useState(false);
	const [isUploading, setIsUploading] = useRecoilState(isUploadingAtom);
	const [isHover, setIsHover] = useState(false);
	const [uploadPercentage, setUploadPercentage] = useState(0);
	const [generateProgress, setGenerateProgress] = useRecoilState(generateProgressAtom)
	const [stopChat, setStopChat] = useRecoilState(stopChatAtom)
	const [, setGenerateStage] = useRecoilState(generateStageAtom)
	const setTaskInit = useSetRecoilState(taskInitAtom)
	const setMeshProfile = useSetRecoilState(meshProfileAtom)
	const [logInfo, ] = useRecoilState(logInfoAtom)
	const [, setModelHide] = useRecoilState(modelHideAtom)
	const [currentCards,setcurrentCards]=useRecoilState(currentCardsAtom)
	const [,setImgCard]=useRecoilState(imgCardAtom)
	const [generated,setGenerated]=useRecoilState(generatedAtom)
	const [,setGenerating]=useRecoilState(generatingAtom)
	const [generate,]=useState(true)


	
	useEffect(() => {
		if (!taskInit) {

		} else {
			
			setStopChat(true)
			
			generateDetail({ task_uuid: taskInit.task_uuid, prompt })	
		}
	}, [taskInit])




	useEffect(() => {
		if (taskDetail || !stopChat) {
			clearInterval(intervalRef.current)
			intervalRef.current = null
			return
		}

		clearInterval(intervalRef.current) //TODO 退出再重进请求2x
		intervalRef.current = setInterval(async () => {
			const { data } = await getGenerateProgress(taskInit.task_uuid)
			if (data.stage === 'Done') {
				setGenerateProgress({ stage: 'Downloading', percent: 100, payload: data })
				clearInterval(intervalRef.current)
				intervalRef.current = null
				const response = await getTaskDetail(taskInit.task_uuid)
				setTaskDetail(response.data)
				setGenerating(false)
			} else {
				setGenerateProgress({
					stage: data.stage,
					percent: data.percentage || 0,
					payload: data,
				})
			}
		}, 1000)
	}, [taskDetail, stopChat])

	
	

	const handleGenerate = (ev) => {
		if (!prompt) return

		if (!logInfo) {
			return;
		}

		if (generateProgress.stage) {
			console.log(generateProgress.stage)
			return;
		}
		setGenerating(true)
		setGenerated(true)
		setTaskDetail(false)
		setStopChat(false)
		setMeshProfile(false)
		setGenerateStage('generate')
		setGenerateProgress(false)
		startChat()
			.then((data) => {
				if (data) {
					const taskInit = data.data
					setTaskInit(taskInit)
				}		
			})
			.catch((err) => {
				console.log(err.message)
			})
			.finally()
	}
	

	const handleClear = (ev) => {
		setGenerateProgress(false)
		if (window.static_project) {
			console.log("hide scene")
			window.static_project.hide_scene()
			setModelHide(true)
		}
		setPrompt('')
		setTaskDetail(false)
	}

	const handleIpt = (ev) => {
		setPrompt(ev.currentTarget.value)

	}

	const changeTCards=()=>{
		if(currentCards==='ImagineFace'){
			clearInterval(intervalImgRef.current);
			setcurrentCards('DreamFace')
			setUploadPercentage(0);
			setUploadImgBlob(null)
			setGenerateProgress(false)
			setGeneratestate(false)
			setImgurls(false)
			setTaskDetail(false)
			setTaskid(false)
			setGenerateurls([])
			setImgCard(false)
			setIsUploading(false)
			setImgfile(null)
			setGenerated(false)
			setGenerating(false)
		}
		
	}

	const changeICards=()=>{
		if(currentCards==='DreamFace'){
			clearInterval(intervalRef.current)
			if (window.static_project) {
				window.static_project.stop()
			}
			setcurrentCards('ImagineFace')
			setGenerateProgress(false)
			setGeneratestate(false)
			setPrompt('')
			setTaskDetail(false)
			setMeshProfile(false)
			setGenerated(false)
			setTaskid(false)
			setGenerating(false)
		}
		
	}


	const handleFileInputChange = async (e) => {
		setShowImgBox(true)
		setUploadImgBlob(e.target.files[0])
		const reader=new FileReader()
		reader.readAsDataURL(e.target.files[0])
        reader.onloadend=function(e){
            setImgfile(e.target.result)
        }
        
	}

	const handleFileDrop=async (event)=>{
		event.preventDefault();
		setFileDropHover(false);
		setUploadImgBlob(...event.dataTransfer.files)
		const reader=new FileReader()
		reader.readAsDataURL(...event.dataTransfer.files)
        reader.onloadend=function(e){
            setImgfile(e.target.result)
        }
		
	}

	const handleUploadIconClick=()=>{
		setGenerateurls(null)
		setTaskid(false)
		fileInputRef.current.value = '';
        fileInputRef.current.click();
	}

	const handleUpload=async ()=>{
		
		setIsUploading(true);
        setUploadPercentage(0);
		setGenerated(true)
		const formData=new FormData()
        formData.append('images',uploadImgBlob)
		const task_id=await ImaginefaceSubmit(formData)
		setTaskid(task_id.data.message)
		intervalSelectionId.current=setInterval(async ()=>{
			if(uploadPercentage<=80){
				setUploadPercentage((old)=>old+20)
			}
			if(uploadPercentage>=80){
				setUploadPercentage(80);
			}
			const url=await ImaginefaceSelection(task_id.data.message)
			if (url===undefined){
				clearInterval(intervalSelectionId.current);
			}
			else if(url.data.urls && url.data.urls.length >= 1){
				setUploadPercentage(100);
				setImgurls(url.data.urls[0])
			  	clearInterval(intervalSelectionId.current);
			}
		},1000)
	}

	useEffect(()=>{
		if(imgurls.length>0){
			handleImgGenerate()
		}
	},[imgurls])

	const handleImgGenerate =async ()=>{
		if(imgfile){
			setImgfile(null)
			
			setGenerating(true)
			const message=await ImaginefaceGenerate(taskid)
			intervalImgRef.current=setInterval(async ()=>{
				const process=await getGenerateProgress(message.data.message)
				setGenerateprocess(process.data.percentage)
				if(process.data.on_progress){
					setGeneratestate(process.data.on_progress[0])
				}
				setGenerateProgress({
					stage: process.data.stage,
					percent: process.data.percentage || 0,
					payload: process.data,
				})
				if(process.data.stage==='Done'){
					
					setGenerateProgress({
						stage: 'Done',
						percent: 100,
						payload: process.data,
					})
					setGenerateprocess(100)
					setGeneratestate('Done')
					setGenerating(false)
					clearInterval(intervalImgRef.current);
				}
			},1500)
		}
		
	}

	const handleImgClear=()=>{
		fileInputRef.current.value = '';
		clearInterval(intervalSelectionId.current);
		setImgfile(null)
		setUploadImgBlob(null)
		setIsUploading(false);
		setImgurls(false)
		setTaskid(false)
		setGenerateprocess(false)
		setGenerateurls([])
	}


	return (
		<>
			<div>
				<h2>Deemos Technology - Hyperhuman Demo</h2>
				<div style={{display:'flex',justifyContent:'center',gap:2,userSelect:'none'}}>
					<button onClick={changeICards} className={style.changeIButton} style={{background:currentCards==='DreamFace'?"white":''}}><img src={ImagePng}/></button>
					<button onClick={changeTCards} className={style.changeButton} style={{background:currentCards==='DreamFace'?'':"white"}}><img src={TextPng}/></button>
				</div>
				<p className={style.descriptionLogin}>
				This is a demo of Deemos Technology's Hyperhuman platform. 
				For more features, please visit our main site
				<a href="https://hyperhuman.deemos.com" target='_blank'> hyperhuman.deemos.com</a>
				</p>
			</div>	
			{currentCards==='DreamFace'?
				<div className={style.colHead}>
					<div className={style.colInner} >
						<div className={style.colTitle}>Positive Prompt</div>
						<textarea
							className={style.iptArea}
							value={prompt}
							placeholder={'Type your prompt here.'}
							onChange={handleIpt}
						/>
					</div>
					<div className={style.btnCon}>
						<div
							className={`${style.clearBtn} ${
								prompt && !generated ? '':style.disabled 
							}`}
							onPointerDown={handleClear}
						>
							Clear
						</div>			
						<div
							className={`${style.generateBtn} ${
								prompt && !generated ? '':style.disabled
							}`}
							onPointerDown={handleGenerate}
						>
							Generate
						</div>
					</div>
				</div>:
				<div className={style.colHead} >
					<div className={`${style.fileDropBox} ${fileDropHover ? style.uploadHover : ''}`} onClick={handleUploadIconClick} onDrop={handleFileDrop}
						onDragOver={(event) => {
							event.preventDefault();
							setFileDropHover(true);
						}}
						onDragEnter={(event) => {
							event.preventDefault();
							setFileDropHover(true);
						}}
						onDragLeave={(event) => {
							event.preventDefault();
							setFileDropHover(false);
					}}>
						{!imgfile && !isUploading && <BsCloudArrowUpFill className={style.uploadIcon} />}
						{!isUploading && <div className={style.tipText}>
                            Drag & Drop or Choose File to Upload Images.
                        </div>}
						{!imgfile && !isUploading && <div
                            onMouseLeave={() => setIsHover(false)}
                            className={style.placehoderText}
                        >
                            <span
                                onMouseEnter={() => setIsHover(true)}
                                className={`${isHover ? style.spanhover : ''} ${style.textspan}`}
                            >
                            {isHover ? <span className={style.hoverText}>Recommended style reference</span>
                                :  (
                                        <>
                                            {' '}
                                            Please provide a clear portrait
                                            with
                                            {' '}
                                            <span>bright lighting</span>
                                            {' '}
                                            and
                                            {' '}
                                            <span>no shadows.</span>
                                        </>
                                    )}
                            </span>
                            {isHover && (
                                <>
                                    <div className={style.placeHodler} />
                                    <div className={style.previewWrapper}>
                                        {['/assets/imagedemo-girl.jpg', '/assets/imagedemo-older.jpg', "/assets/imagedemo-boy.jpg"].map((item, index) => (
                                            <div key={index} className={style.previewBox}>
                                                <img src={item} alt="defaultImg" />
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>}
						{imgfile && !isUploading && <div className={style.thumbnailItem}>
							<img src={imgfile} alt="thumbnail" />
						</div>}
						{/* {imgfile && !isUploading && <div className={style.uploadBtn} onClick={(e) => {
                                e.stopPropagation();
                                handleUpload();
                            }}
                        >
                            Upload
                        </div>} */}
						{isUploading && 
							<>
								<div className={style.progressText}>
									{uploadPercentage === 100 ?  'Complete' : 'Uploading...'}
								</div>
								<div className={style.ProgressBar}>
									<div
										className={style.filler}
										style={{
											width: `${uploadPercentage}%`,
										}}
									/>
								</div>
							</>
						}
						<input
							type="file"
							key={Math.random}
							ref={fileInputRef}
							style={{ display: 'none' }}
							onChange={handleFileInputChange}
							accept=".jpg, .jpeg, .png"
						/>
					</div>
					<div className={style.btnCon}>
						<div
							className={`${style.clearBtn} ${
								imgfile && !generated ? '':style.disabled 
							}`}
							onPointerDown={handleImgClear}
	
						>
							Clear
						</div>			
						<div
							className={`${style.generateBtn} ${
								imgfile && !generated ? '': style.disabled
							}`}
							onPointerDown={handleUpload}
						>
							Generate
						</div>
					</div>
				</div>}
		</>

	)
}

export { GenerateBoard, generateProgressAtom, modelHideAtom }
